import { render, staticRenderFns } from "./StaticMap.vue?vue&type=template&id=5c065980&"
import script from "./StaticMap.vue?vue&type=script&lang=js&"
export * from "./StaticMap.vue?vue&type=script&lang=js&"
import style0 from "./StaticMap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports